import React from 'react';
import Link from 'next/link';
import Button from '@mui/material/Button';
import { QUERY_SCROLL } from '@/constants/auth';
import { RESUME_CONSULT_SERVICE_ID } from '@/constants/component-id';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { RESUME_CONSULTATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';
import { useGsapContextSafe } from '@/utils/hooks/useGsapScroll';

const ConsultationBtn = (props: { dataEleGroup: string; isLink?: boolean }) => {
  const { dataEleGroup, isLink } = props;

  const isMobile = useClintMediaQuery();

  const handleScroll = useGsapContextSafe();

  if (isLink) {
    return (
      <Button
        variant="contained"
        className="w-full h-13.5 max-w-[340px] !font-semibold tablet:w-[220px]"
        data-ele-id="btn_简历咨询"
        data-ele-group={dataEleGroup}
        LinkComponent={Link}
        href={`${RESUME_CONSULTATION_ROUTER_PATH}?${QUERY_SCROLL}=true`}
        onClick={(e) => trackClickEvent(e)}
      >
        预约导师
      </Button>
    );
  }

  return (
    <Button
      variant="contained"
      className="w-full h-13.5 max-w-[340px] !font-semibold tablet:w-[220px]"
      data-ele-id={`resume-service_${dataEleGroup}`}
      data-ele-group={dataEleGroup}
      onClick={(e) => {
        trackClickEvent(e);
        handleScroll({
          scrollId: RESUME_CONSULT_SERVICE_ID,
          offsetY: BASE_HEADER_HEIGHT * (isMobile ? 1.1 : 2),
        });
      }}
    >
      预约导师
    </Button>
  );
};

export default ConsultationBtn;
